<template>
  <div class="ml2">
    <div
      v-if="panelFootnotes.length > 0"
      class="b"
    >Footnotes</div>
    <template v-for="(fn, index) in panelFootnotes">
      <div
        :key="index"
        class="dt pl1"
      >
        <div class="dtc w2">
          {{ fn.fs }}
        </div>
        <div class="dtc">
          {{ fn.ft }}
        </div>
      </div>
    </template>

    <div
      v-if="notes.length > 0"
      class="b">Note:</div>
    <template v-for="(n, index) in notes">
      <div
        :key="index"
        class="pl3"
      >
        {{ n.ft }}
      </div>
    </template>

    <div v-if="indicatorDefinitionText.length > 0">
      <a
        :href="indicatorDefinitionUrl"
      >{{ indicatorDefinitionText }}</a>
    </div>

    <div>
      <span class="b">Data Source: </span>
      <a
        :href="dataSourceUrl"
        target="_blank">{{ dataSourceFootnoteText }}</a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import helper from '../../helper';

export default {
  props: {
    instance: {
      type: Number,
      default: 0,
    },
    filteredData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    ...mapState({
      footnotes: state => state.footnotes,
      indicators: state => state.SP.indicators,
      lku: state => state.lku,
      GSGo: state => state.SP.GSGo,
    }),
    indicatorId() {
      return this.indicators[this.instance].id;
    },
    panelFootnotes() {
      let fnsymbols = _(this.filteredData).map('fn').uniq().value();
      // note fnsymbols => [undefined] if none of the rows have a fn property
      // use compact to convert this to an empty array
      fnsymbols = _.compact(fnsymbols);
      let footnotes = _(fnsymbols).map(x => _(this.footnotes).find({ fs: x, type: 'Footnote' }))
        .orderBy('sort', 'asc').value();
      // Add special footnote if found in the footnotes table for the current indicator.id, year, and locationId match a Footnote row
      const locationAbbr = this.lku.Location[this.GSGo.locationId].abbr;
      const filteredYear = this.lku.Year[this.filteredData[0].yr].name;
      const filteredIndicator = this.indicatorId;
      const specialFootnote = _(this.footnotes).filter({ type: 'Footnote' }).find((fn) => {
        const match = (filteredIndicator === fn.qc || fn.qc === 'All') && filteredYear === fn.yr && locationAbbr === fn.sc;
        // console.log(filteredIndicator, filteredYear, locationAbbr, fn.qc, fn.yr, fn.sc, match);
        return match;
      });
      if (specialFootnote) {
        footnotes = _.concat(footnotes, specialFootnote);
        footnotes = _(footnotes).orderBy('sort', 'asc').value();
      }
      // use compact to remove undefined array values which could occur if the
      // footnote symbol is not in the footnote table
      // TODO: add notification if footnote symbol is missing
      return _.compact(footnotes);
    },
    notes() {
      return _(this.footnotes).filter({ qc: this.indicatorId, type: 'Note' })
        .orderBy('sort', 'asc').value();
    },
    indicatorDefinitionText() {
      const row = _(this.footnotes).find({ qc: this.indicatorId, type: 'IndicatorDefinition' });
      return row ? row.ft : '';
    },
    indicatorDefinitionUrl() {
      const row = _(this.footnotes).find({ qc: this.indicatorId, type: 'IndicatorDefinition' });
      return row ? helper.convertRelativeUrlToWCMSUrl(row.url) : '';
    },
    dataSourceUrl() {
      const row = _(this.footnotes).find({ type: 'PanelDataSource' });
      return row ? helper.convertRelativeUrlToWCMSUrl(row.url) : '';
    },
    dataSourceFootnoteText() {
      const row = _(this.footnotes).find({ type: 'PanelDataSource' });
      return row ? row.ft : '';
    },
  },
};
</script>

<style scoped>
  .ml2 {
    margin-left: .5rem;
  }

  .b {
    font-weight: bold;
  }

  .dt {
    display: table;
  }

  .dtc {
    display: table-cell;
  }

  .pl1 {
    padding-left: .25rem;
  }

  .pl3 {
    padding-left: 1rem;
  }

  .w2 {
    width: 2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/SP/SPPanelFootnotes.vue